// Rage Click is a click event that is triggered more than 3 times within 1 second  
// For example:
// All three clicks are on the same element ("A")
// Each consecutive click is within 1000ms of the previous one
// The total count reaches 3 
const RAGE_CLICK_THRESHOLD = 1000;
const RAGE_CLICK_COUNT = 3;
export default class RageClick {
    
    clickArray: {selector: string, timestamp: number}[];
    constructor() {
        this.clickArray = [];
    }

    isRageClick(selector: string, currentClickTime: number) {

        const lastClick = this.clickArray[this.clickArray.length - 1];
    
        if (lastClick && lastClick.selector === selector && currentClickTime - lastClick.timestamp <= RAGE_CLICK_THRESHOLD) {
            this.clickArray.push({ selector, timestamp: currentClickTime });
    
            if (this.clickArray.length >= RAGE_CLICK_COUNT) {
                return true;
            }
        } else {
            this.clickArray = [{ selector, timestamp: currentClickTime }];
        }
      
        return false;
    }
}